var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "15px",
    viewBox: "0 0 25 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eye-on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-on",
    fill: "#767676",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9074392,7.195723 C24.7105609,6.90106373 19.9792311,0 12.4999545,0 C6.08212165,0 0.363275171,6.86143765 0.122646112,7.15393733 C-0.0408820373,7.35322282 -0.0408820373,7.64572249 0.122646112,7.84606267 C0.363275171,8.13856235 6.08212165,15 12.4999545,15 C18.9177874,15 24.6365851,8.13856235 24.8772141,7.84606267 C25.0282909,7.6617939 25.0418165,7.39500849 24.9074392,7.195723 Z M12.4862015,14 C7.24698356,14 2.26548755,8.8975 1,7.5 C2.26339912,6.10143359 7.23957462,1 12.4862015,1 C18.6164817,1 22.9434546,6.09493359 24,7.47075 C22.7800601,8.82381641 17.7699725,14 12.4862015,14 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4997559,3.15732422 C10.2018555,3.15732422 8.33310547,5.02607422 8.33310547,7.32397461 C8.33310547,9.621875 10.2018555,11.490625 12.4997559,11.490625 C14.7976563,11.490625 16.6664063,9.621875 16.6664063,7.32397461 C16.6664063,5.02607422 14.7976563,3.15732422 12.4997559,3.15732422 Z M12.4997559,10.4490234 C10.7768555,10.4490234 9.37475586,9.04692383 9.37475586,7.32402344 C9.37475586,5.60112305 10.7768555,4.19902344 12.4997559,4.19902344 C14.2226563,4.19902344 15.6247559,5.60112305 15.6247559,7.32402344 C15.6247559,9.04692383 14.2226563,10.4490234 12.4997559,10.4490234 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye-on.5aac96b65991d9e531558c90c25c3305.svg";
export { ForwardRef as ReactComponent };